import React from 'react';
import { useAuth } from '../context/AuthContext';
import BudgetDashboard from './ManageBudget';
import DepartmentBudgetManagement from './DepartmentBudgetManagement';
import { isDepartmentManager } from '../utils/roleHelpers';

/**
 * Route Department Managers to their specific budget management page
 * Route other roles to the company-wide budget dashboard
 */
export default function BudgetDashboardRouter() {
  const { user } = useAuth();

  // Department Managers see their department budget management
  if (isDepartmentManager(user)) {
    return <DepartmentBudgetManagement />;
  }

  // All other roles see company-wide budget dashboard
  return <BudgetDashboard />;
}
